import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const useOptsByOrgId = (orgId: string | null) => {
  return useQuery({
    queryKey: ['optsByOrgId', orgId],
    queryFn: async () => {
      if (!orgId) return []
      const { data } = await axios.get(`${baseUrl}/aws/optimizations/query-org`, {
        params: { orgId },
      })
      return data || []
    },
    enabled: !!orgId, // ✅ Only run if orgId exists
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 2, // Retry twice on failure
  })
}
